<template>
    <div>
        <AtomTitle>Документы</AtomTitle>
        <div
            ref="slider-container"
            class="swiper mt-5 lg:mt-10">
            <div class="swiper-wrapper flex items-stretch">
                <div
                    v-for="item in items"
                    :key="item.title || item.id"
                    class="swiper-slide !h-auto !w-[17.5rem] md:!w-[27.5rem]">
                    <DocumentCard
                        :document="item.document"
                        :title="item.title"
                        class="!max-w-none" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Swiper } from 'swiper'
import 'swiper/css'

import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import DocumentCard from '~/components/base/document-card/DocumentCard.vue'
import type { IProductLineBlock } from '~/components/particles/product-line-blocks-section/product-line-blocks-section.types'

defineProps({
    items: {
        type: Array as PropType<IProductLineBlock[]>,
        required: true,
    },
})

const sliderRef = useTemplateRef('slider-container')

const initSlider = () => {
    if (!sliderRef.value) return

    new Swiper(sliderRef.value, {
        slidesPerView: 'auto',
        spaceBetween: 20,
    })
}

onMounted(initSlider)
</script>
